/**
 * Queries the location eligibility API by ZIP code.
 * @param normalizedZip - A sanitized 5-digit ZIP code
 * @returns Location data on success, or an object with error/errorMessage on failure
 */
export const queryLocationByZip = async (normalizedZip: string) => {
  try {
    const response = await fetch(
      `/api/psx-buy/location-eligibility?zip=${encodeURIComponent(normalizedZip)}`,
    );
    const data = await response.json();

    if (!response.ok || data?.error) {
      return {
        error: true,
        errorMessage:
          data?.errorMessage ||
          'Unable to determine location for provided ZIP code.',
      };
    }

    return data;
  } catch (_error) {
    return {
      error: true,
      errorMessage: 'Unable to determine location for provided ZIP code.',
    };
  }
};
